import { render, staticRenderFns } from "./ToiletList.vue?vue&type=template&id=2b4ad21e&scoped=true&lang=pug"
import script from "./ToiletList.vue?vue&type=script&lang=ts"
export * from "./ToiletList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ad21e",
  null
  
)

export default component.exports